import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Student, StudentState } from '../types/student';

const initialState: StudentState = {
  students: [],
  loading: false,
  error: null,
};

const studentSlice = createSlice({
  name: 'students',
  initialState,
  reducers: {
    fetchStudentsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchStudentsSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.students = action.payload;
    },
    fetchStudentsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addStudentStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addStudentSuccess: (state, action: PayloadAction<Student>) => {
      state.loading = false;
      state.students.push(action.payload);
    },
    addStudentFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateStudentStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateStudentSuccess: (state, action: PayloadAction<Student>) => {
      state.loading = false;
      state.students = state.students.map((student) =>
        student.id === action.payload.id ? action.payload : student
      );
    },
    updateStudentFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteStudentStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteStudentSuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.students = state.students.filter((student) => student.id !== action.payload);
    },
    deleteStudentFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchStudentsStart,
  fetchStudentsSuccess,
  fetchStudentsFailure,
  addStudentStart,
  addStudentSuccess,
  addStudentFailure,
  updateStudentStart,
  updateStudentSuccess,
  updateStudentFailure,
  deleteStudentStart,
  deleteStudentSuccess,
  deleteStudentFailure,
} = studentSlice.actions;

export default studentSlice.reducer;